import { IColuna } from "app/types/IColuna";
import { IOrcamento } from "app/types/IOrcamento";
import { RespostaConsultaItensOrcamento } from "app/types/orcamento/consultaItens/RespostaConsultaItensOrcamento";
import { Parametro } from "app/types/Parametro";
import * as R from 'ramda'
import { obterColunasEstoquesFiliaisConsultarItens } from "./obterColunasEstoquesFiliaisConsultaritens";

export type ObterColunasConsultaItensParams = {
    colunasDoCadastroDoUsuario: IColuna[]
    parametros: Parametro[]
    parametrosPorFilial: Parametro[]
    tipoOrcamento: IOrcamento["TipoOrcamentoDescricao"]
    permissaoAcaoMostrarLocalRetirada: boolean
    estoques: RespostaConsultaItensOrcamento["Itens"][0]["ListEstoqueProduto"]["Estoques"]
    codigoFilialOrcamento:string
}
/*


Atenção, se incluir alguma coluna no grid de itens, tem que incluir tambem na consulta de itens (ItemConsultaItens)



*/
// Colunas "*" (derivadas): não existem no cadastro de grid do usuário — são calculadas/repetidas no
// front. Entram aqui como coluna normal para aparecerem na engrenagem e poderem ser ocultadas.
export const COLUNAS_DERIVADAS_CONSULTA_ITENS = [
    "PrecoUnitarioTabelaAsterisco",
    "PercentualDescontoAsterisco"
]

const ordemColunas = [
    "CodigoProduto",
    "DescricaoProduto",
    "Quantidade",
    "PrecoProduto",
    "ValorTotal",
    "PrecoUnitarioTabela",
    "PrecoUnitarioTabelaAsterisco",
    "PrecoTotalTabela",
    "PrecoUnitarioAVista",
    "PrecoTotalAVista",
    "PercentualMarkUp",
    "MarkupMinimo",
    "PrecoVendaMinimoCustoReal",
    "PercentualDesconto",
    "PercentualDescontoAsterisco",
    "CodigoTipoEntrega",
    "Carga",
    "CodigoFilialRetirada",
    "CodigoFilialTransferencia",
    "TipoFaturamento",
    "VendaSobEncomenda",
    "EncomendaExpressa", // 433263
    "EntregaPosterior",
    "Mostruário",// PA 487087
    "QuantidadeDevolvida",
    "NfDevolucao",
    "Pendencia",
    "Volume",
    "Peso",
    "Ambiente",
    "CentroDeCusto"
]

export const compararColunas = (c1: IColuna, c2: IColuna, codigoFilialOrcamento: string) => {
    const colunasSaoDeEstoqueDeFiliais = () => {
        const r = /F[0-9]{2}/

        return r.test(c1.Nome) && r.test(c2.Nome)
    }

    const compararColunasEstoqueFiliais = () => {
        return  c1.Nome == `F${codigoFilialOrcamento}` ? -1 :
                c2.Nome == `F${codigoFilialOrcamento}` ?  1 :
                c1.Nome.localeCompare(c2.Nome)
    }

    const compararColunasNormais = () => {

        const posicaoC1 =   c1.ehEstoqueFilial ? ordemColunas.findIndex(c => c == "PrecoVendaMinimoCustoReal") : 
                            ordemColunas.findIndex(nomeColuna => nomeColuna == c1.Nome)
        
        const posicaoC2 =   c2.ehEstoqueFilial ? ordemColunas.findIndex(c => c == "PrecoVendaMinimoCustoReal") :
                            ordemColunas.findIndex(nomeColuna => nomeColuna == c2.Nome)
        

        const c1Existe = () => posicaoC1 != -1
        const c2Existe = () => posicaoC2 != -1

        return  c1Existe() && !c2Existe() ? -1 :
                !c1Existe() && c2Existe() ? 1 : 
                c1Existe() && c2Existe() ? posicaoC1 - posicaoC2 :
                0
    }

    return colunasSaoDeEstoqueDeFiliais() ? compararColunasEstoqueFiliais() : compararColunasNormais()
}

export function obterColunasConsultaItens(params: ObterColunasConsultaItensParams) : IColuna[] {
    const colunaCadastroUsuarioDeveSerExibida = (coluna: IColuna) : boolean => {
        const colunasParaNaoExibir = ["preço Unitario","Quant", "Info"]
        const colunaEhDeEstoqueDeFilial = () => /F[0-9]{2}/.test(coluna.Nome)

        // As derivadas saem daqui e voltam por `obterColunasDerivadas` (que reaproveita a marcação
        // gravada) — senão apareceriam duas vezes depois do primeiro toggle, que grava a lista
        // inteira no cadastro.
        return !R.includes(coluna.Nome, colunasParaNaoExibir) &&
            !R.includes(coluna.Nome, COLUNAS_DERIVADAS_CONSULTA_ITENS) &&
            !colunaEhDeEstoqueDeFilial()
    }

    // Marcação (exibir/ocultar) das derivadas: usa a do cadastro se o usuário já mexeu na
    // engrenagem; na primeira vez nasce exibida.
    const obterColunasDerivadas = () : IColuna[] =>
        COLUNAS_DERIVADAS_CONSULTA_ITENS.map(nome => {
            const colunaDoCadastro = params.colunasDoCadastroDoUsuario.find(c => c.Nome == nome)

            return {
                Codigo: -1,
                Nome: nome,
                Permitido: colunaDoCadastro?.Permitido ?? true,
                Selecionada: colunaDoCadastro?.Selecionada ?? true
            } as IColuna
        })

    const handleColuna: {[nomeColuna:string] : () => boolean} = {}

    const removerColunasDuplicadas = (colunas:IColuna[]) : IColuna[] => {
        return colunas.reduce((colunasNaoDuplicadas, coluna) => {
            return R.includes(coluna.Nome, colunasNaoDuplicadas.map(c => c.Nome)) ? colunasNaoDuplicadas : R.append(coluna, colunasNaoDuplicadas)
        }, [])
    }

    const colunas_ = [
        ...removerColunasDuplicadas(params.colunasDoCadastroDoUsuario.filter(colunaCadastroUsuarioDeveSerExibida)),
        ...obterColunasDerivadas(),
        ...obterColunasEstoquesFiliaisConsultarItens(params.estoques, params.colunasDoCadastroDoUsuario).filter(c => c.Permitido != false),
    ]

    const colunasOrdenadas = R.sort((c1,c2) => compararColunas(c1,c2, params.codigoFilialOrcamento), colunas_)

    colunasOrdenadas.forEach(coluna => handleColuna[coluna.Nome] = R.T)

    const valorParametro = (nome:string) => params.parametros.find(p => p.Nome == nome)?.Valor

    handleColuna["PercentualMarkUp"] = handleColuna["MarkupMinimo"] = handleColuna["PrecoVendaMinimoCustoReal"] = () => {
        const ehPapelaria = 
            valorParametro("CUSTO_PARA_GERAR_MARKUP") == "28889" && 
            valorParametro("VISUALIZA_MARKUP_PRODUTO_ORCAMENTO") == "S" // && 
            //valorParametro("DESABILITAR_PAGINA_ORDEM_SEPARACAO_CONFERENCIA_SAIDA") == "S"

        return params.tipoOrcamento == "Venda" && ehPapelaria
    }

    handleColuna["CodigoFilialRetirada"] = handleColuna["CodigoFilialTransferencia"] = handleColuna["TipoFaturamento"] = () => {
        return params.permissaoAcaoMostrarLocalRetirada == true &&
        (params.tipoOrcamento == "Venda" || (params.tipoOrcamento == "Outras Saídas" && valorParametro("ORCAMENTO_OUTRAS_SAIDAS_RETIRADA_OUTRO_LOCAL") == "S"))
    }

    handleColuna["CentroDeCusto"] = handleColuna["PedidoCompra"] = handleColuna["LinhaOrdemCompra"] = () => {
        return params.tipoOrcamento == "Venda"
    }

    handleColuna["Ambiente"] = () => {
        return params.tipoOrcamento == "Transferências" && 
                    (valorParametro("AMBIENTE_ORCAMENTO_POR_FILIAL") == "S" || valorParametro("AMBIENTE_ORCAMENTO") == "S")
    }
/* duplicado acima
    handleColuna["CentroDeCusto"] = handleColuna["PedidoCompra"] = handleColuna["LinhaOrdemCompra"] = () => {
        return params.tipoOrcamento == "Venda"
    }
*/
    handleColuna['VendaSobEncomenda'] = () => {
        const  parametroDefinirVendaSobEncomenda = params.parametros.find(p => p.Nome == 'TRATAR_VENDAS_SOB_ENCOMENDA')?.Valor;
        return parametroDefinirVendaSobEncomenda != "0" && parametroDefinirVendaSobEncomenda != "" && parametroDefinirVendaSobEncomenda != null
    }

    handleColuna['EncomendaExpressa'] = () => { // 433263
        const  parametroDefinirVendaSobEncomenda = params.parametros.find(p => p.Nome == 'TRATAR_VENDAS_SOB_ENCOMENDA')?.Valor;
        return params.parametrosPorFilial.find(p => p.Nome == 'UTILIZA_RECURSO_ENCOMENDA_EXPRESSA')?.Valor == "S" 
                        &&  parametroDefinirVendaSobEncomenda != "0" && parametroDefinirVendaSobEncomenda != "" && parametroDefinirVendaSobEncomenda != null
    }

    handleColuna['EntregaPosterior'] = () => {
        return params.parametros.find(p => p.Nome == 'VENDA_COM_ENTREGA_POSTERIOR_POR_ITEM')?.Valor == "S";
    }

    handleColuna['Mostruário'] = () => {
        return params.tipoOrcamento == "Venda" || params.tipoOrcamento == "Outras Saídas";
    }
    return colunasOrdenadas.filter(coluna => handleColuna[coluna.Nome]())
}